import React from 'react'
import Editable from './Editable';
import { EditableCellProps } from './types';

function EditableCell(props: EditableCellProps) {
    const {
        editable,
        children,
        record,
        dataIndex,
        index,
        isSelect,
        handleSave,
        isFile,
        maskOptions,
        rules,
        selectOptions,
        ...restProps
    } = props;
    return <td {...restProps}>
        {
            editable
                ? <Editable {...props} />
                : children
        }
    </td>;
}

function arePropsEqual(oldProps: EditableCellProps, newProps: EditableCellProps) {
    if (oldProps?.record) {
        return oldProps.index === newProps.index &&
            oldProps.record[oldProps.dataIndex] === newProps.record[newProps.dataIndex]
    }

    return oldProps.index === newProps.index && oldProps.title !== undefined
}

export default React.memo(EditableCell, arePropsEqual)
